import * as Http from '../Components/Http'

const localBackendOrigin = "https://localhost:7236";

const GetBackendOrigin = () =>{
   
    //check if the react app was loaded from a link on the back end or "npm start"
    const scriptElement = document.getElementById('FormComponent');	

    //npmstart
    if(!scriptElement) {
        return localBackendOrigin;
    }

    //by form object's script src
    const scriptSrc = document.getElementById('FormComponent').src;	
    var url = new URL(scriptSrc);
    return url.origin;    
}

export const GetScriptJsonUrl = (token, appId, formId) =>{

    const backendOrigin = GetBackendOrigin(); 
    if (token){
        return `${backendOrigin}/forms/api/form/${token}`;
    }
    else{
        return `${backendOrigin}/forms/api/form/${appId}/${formId}`;
    }
}

export const GetOriginUrl = () =>{
    const backendOrigin = GetBackendOrigin(); 
    return `${backendOrigin}/forms/form-component`;
}

export function PostForm(formData) {
    const backendOrigin = GetBackendOrigin();
    return Http.Post(`${backendOrigin}/forms/api/form`, formData);
}
